import { render } from "./OutdatedVendorPartnerEmails.vue?vue&type=template&id=3fd0a5c1&scoped=true"
import script from "./OutdatedVendorPartnerEmails.vue?vue&type=script&lang=js"
export * from "./OutdatedVendorPartnerEmails.vue?vue&type=script&lang=js"

import "./OutdatedVendorPartnerEmails.vue?vue&type=style&index=0&id=3fd0a5c1&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd0a5c1"]])

export default __exports__